import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_GEWICHTSPORTAL_STABLE } from '../gewichtsportal.api';
import { Stable } from '../types/stable.model';
import { StableQuery } from '../types/stable-query';

@Injectable()
export class StableRepository extends ReadonlyHttpApiListRepository<
  Result<Stable[]>,
  StableQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GEWICHTSPORTAL_STABLE);
  }

  override getLoadQueryParams(params: StableQuery): Dictionary<unknown> | undefined {
    return params.idfattener ? { idfattener: params.idfattener } : undefined;
  }
}
